import { command } from "../../../app/command";
import { query } from "../../../app/query";
import { EventPayload } from "../../../common/types/Event";
import { Options } from "../../../common/types/requestOptions";
import {
  CreateEmployerHealthInsuranceReduction,
  DeleteEmployerHealthInsuranceReduction,
  EmployerHealthInsuranceReductionEventPayload,
  EmployerHealthInsuranceReductionParams,
  EmployerHealthInsuranceReductionsResponse,
  UpdateEmployerHealthInsuranceReduction,
} from "./types";

export const getEmployerHealthInsuranceReductions = (
  filters: EmployerHealthInsuranceReductionParams,
  options: Options = {},
): Promise<EmployerHealthInsuranceReductionsResponse> =>
  query<{}, EmployerHealthInsuranceReductionsResponse>(
    "/projections/qry/employerHealthInsuranceReductions",
    filters,
    options,
  );

export const createEmployerHealthInsuranceReduction = async (
  body: CreateEmployerHealthInsuranceReduction,
  options: Options = {},
): Promise<EventPayload<EmployerHealthInsuranceReductionEventPayload>[]> =>
  command<
    CreateEmployerHealthInsuranceReduction,
    EmployerHealthInsuranceReductionEventPayload
  >("/invoicing/cmd/addEmployerHealthInsuranceReduction", body, options);

export const saveEmployerHealthInsuranceReduction = async (
  body: UpdateEmployerHealthInsuranceReduction,
  options: Options = {},
): Promise<EventPayload<EmployerHealthInsuranceReductionEventPayload>[]> =>
  command<
    UpdateEmployerHealthInsuranceReduction,
    EmployerHealthInsuranceReductionEventPayload
  >("/invoicing/cmd/updateEmployerHealthInsuranceReduction", body, options);

export const removeEmployerHealthInsuranceReduction = async (
  body: DeleteEmployerHealthInsuranceReduction,
  options: Options = {},
): Promise<EventPayload<{}>[]> =>
  command<DeleteEmployerHealthInsuranceReduction, {}>(
    "/invoicing/cmd/deleteEmployerHealthInsuranceReduction",
    body,
    options,
  );
